/* eslint-disable */
import { TextStyle } from './common';
const baseParagraphData = {};
export const ParagraphData = {
    fromJSON(object) {
        const message = Object.assign({}, baseParagraphData);
        message.textStyle =
            object.textStyle !== undefined && object.textStyle !== null
                ? TextStyle.fromJSON(object.textStyle)
                : undefined;
        message.indentation =
            object.indentation !== undefined && object.indentation !== null
                ? Number(object.indentation)
                : undefined;
        message.level =
            object.level !== undefined && object.level !== null ? Number(object.level) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.textStyle !== undefined &&
            (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
        message.indentation !== undefined && (obj.indentation = message.indentation);
        message.level !== undefined && (obj.level = message.level);
        return obj;
    },
};
//# sourceMappingURL=node_paragraph.js.map